import React from 'react';
import { FlatList, FlatListProps } from 'react-native';

const FlatListCustom = (props: FlatListProps<any>) => <FlatList {...props} />;

export default FlatListCustom;
